import { yupResolver } from '@hookform/resolvers/yup';
import { useContext } from 'react';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { CabinetContext } from '../../context';
import { SET_FORM, SET_STEP } from '../../context/types';

export default () => {
  const {
    dispatch,
    state: { form, step, attachments, executionTimes }
  } = useContext(CabinetContext);
  const {
    register,
    handleSubmit,
    watch,
    control,
    formState: { errors, isValid }
  } = useForm({ mode: 'onChange', resolver: yupResolver(schema) });

  const onSubmit = handleSubmit(async (data) => {
    dispatch({ type: SET_FORM, payload: data });
    dispatch({ type: SET_STEP, payload: step + 1 });
  });

  const goBack = () => {
    dispatch({ type: SET_STEP, payload: step - 1 });
  };

  return {
    register,
    control,
    errors,
    onSubmit,
    form,
    goBack,
    attachments,
    executionTimes,
    isValid
  };
};
const schema = yup.object({
  MarketingPlan: yup.object().required('الحقل مطلوب'),
  DeploymentPlan: yup.object().required('الحقل مطلوب'),
  DeploymentPlanBolean: yup.bool().oneOf([true], 'يجب الموافقة على الشروط والأحكام'),
  MaintenancePlan: yup.object().required('الحقل مطلوب')
});
